import React from 'react';
import {
	mergeStyles,
	Theme,
	TextCompat as Text,
} from 'components/FluentUICompat';
import {TFunction} from 'react-i18next';
import {isApprovalModified} from 'features/RegulatoryDocuments/regulatoryUtils';

import {
	RegulatoryDocumentDisassemblyStatus,
	RegulatoryDocumentStatus,
	RequirementCategory,
	RequirementStatus,
	WorkflowStatus,
} from 'types';

const StatusEnums = {
	...WorkflowStatus,
	...RegulatoryDocumentStatus,
	...RequirementStatus,
	...RequirementCategory,
};
// eslint-disable-next-line complexity
export const getStatusTag = (
	status: any,
	theme: Theme,
	t: TFunction,
	reapprovingVKO?: string,
) => {
	let background;
	let color;

	switch (status) {
		case StatusEnums.Draft:
		case StatusEnums.Approval:
		case StatusEnums.New:
		case StatusEnums.ReadyForApproval:
			background = theme.palette.neutralLight;
			color = theme.palette.neutralSecondary;
			break;
		case StatusEnums.Final:
		case StatusEnums.Finalized:
		case StatusEnums.Clearing:
			background = `${theme.palette.greenLight}33`;
			color = theme.palette.green;
			break;
		case StatusEnums.Interpretation:
			background = theme.palette.blueLight;
			color = theme.palette.blue;
			break;
		case StatusEnums.Discarded:
			background = `${theme.palette.red}33`;
			color = theme.palette.redDark;
			break;
		case StatusEnums.Examination:
			background = `${theme.palette.black}`;
			color = theme.palette.white;
			break;
		case StatusEnums.Consideration:
		case StatusEnums.InProgressExternal:
		case StatusEnums.Modified:
		case 'APPROVING_MODIFIED':
			background = `${theme.palette.yellow}33`;
			color = theme.palette.neutralSecondary;
			break;
		case StatusEnums.QualityControlInternal:
		case StatusEnums.QualityControlExternal:
			background = theme.palette.blue;
			color = theme.palette.white;
			break;
		case StatusEnums.InProgressInternal:
			background = theme.palette.tealLight;
			color = theme.palette.white;
			break;
		case StatusEnums.Archived:
			background = theme.palette.orangeLighter;
			color = theme.palette.white;
			break;
		case StatusEnums.ClearingWithReservations:
			background = theme.palette.yellow;
			color = theme.palette.neutralSecondary;
			break;
		case StatusEnums.Interim:
			background = `${theme.palette.greenLight}33`;
			color = theme.palette.green;
			break;
		case StatusEnums.InterimCompleted:
			background = `${theme.palette.greenLight}33`;
			color = theme.palette.green;
			break;
		default:
			break;
	}

	const className = mergeStyles({
		background,
		color,
		paddingLeft: 3,
		paddingRight: 3,
		borderRadius: 3,
	});

	const displayedStatus =
		status === StatusEnums.Modified && isApprovalModified(reapprovingVKO || '')
			? t('APPROVING_MODIFIED')
			: t(status);

	return <Text className={className}>{displayedStatus}</Text>;
};

export const getDisassemblyStatusTag = (
	status: RegulatoryDocumentDisassemblyStatus,
	theme: Theme,
	t: TFunction,
) => {
	let background;
	let color;

	switch (status) {
		case RegulatoryDocumentDisassemblyStatus.DisassemblyOccured:
			background = `${theme.palette.greenLight}33`;
			color = theme.palette.green;
			break;
		case RegulatoryDocumentDisassemblyStatus.DisassembleLater:
			background = `${theme.palette.yellow}33`;
			color = theme.palette.neutralSecondary;
			break;
		case RegulatoryDocumentDisassemblyStatus.DisassemblyNotRequired:
			background = theme.palette.blue;
			color = theme.palette.white;
			break;
		default:
			break;
	}

	const className = mergeStyles({
		background,
		color,
		paddingLeft: 3,
		paddingRight: 3,
		borderRadius: 3,
	});

	return <Text className={className}>{t(status)}</Text>;
};
